<template>
  <div>
    <div class="print-break">
      <h1>재 발 방 지 조 치 &nbsp; 보 고 서</h1>
      <table>
        <colgroup>
          <col width="140" />
          <col />
          <col width="60" />
          <col />
          <col width="140" />
          <col />
          <col width="140" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th>{{ getFieldLabel() }}</th>
            <td colspan="5">{{ form.stdInfo.field_name }}</td>
            <th>담당자</th>
            <td>{{ form.stdInfo.writer_name }}</td>
          </tr>
          <tr>
            <th>재해자 성명</th>
            <td>{{ form.inputB_1 }}</td>
            <th>연령</th>
            <td>{{ form.inputB_2 }}</td>
            <th>수급업체<br />확인여부</th>
            <td>{{ form.inputB_4 }}</td>
            <th>소속사</th>
            <td>{{ form.companyName }}</td>
          </tr>
          <tr>
            <th>주소, 연락처</th>
            <td v-if="form.inputB_5 || form.inputB_6" colspan="7">{{ `${form.inputB_5}${form.inputB_5 && form.inputB_6 ? ", " : ""}` }}{{ form.inputB_6 }}</td>
            <td v-else colspan="7" style="color: #9ca0a4">(직영근로자인 경우에만 기재)</td>
          </tr>
          <tr>
            <th>사고일시</th>
            <td colspan="7">{{ form.inputB_7 }}, {{ form.inputB_8 }}</td>
          </tr>
          <tr>
            <th>재해장소</th>
            <td colspan="7">{{ form.inputB_9 }}</td>
          </tr>
          <tr>
            <th>사고원인</th>
            <td colspan="7">
              <div class="print-textarea no-block" style="min-height: 350px; padding: 7px !important; text-align: justify">{{ form.inputB_11 }}</div>
            </td>
          </tr>
          <tr>
            <th>재발방지조치</th>
            <td colspan="7">
              <div class="print-textarea no-block" style="min-height: 350px; padding: 7px !important; text-align: justify">{{ form.inputB_12 }}</div>
            </td>
          </tr>

          <tr>
            <th>잔존 유해<br />위험 요인<br />조치 계획</th>
            <td colspan="7">
              <div class="print-textarea no-block" style="min-height: 350px; padding: 7px !important; text-align: justify">{{ form.inputB_13 }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="print-break">
      <div class="flex items-center">
        <div style="flex: 2.5">
          <h2>교육내용</h2>
        </div>
        <table class="flex-1 sign">
          <colgroup>
            <col width="38" />
            <col />
            <col />
          </colgroup>
          <tr>
            <th rowspan="2" class="gray p-0">
              <div class="flex justify-center items-center">
                <p style="writing-mode: vertical-lr">결&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;재</p>
              </div>
            </th>
            <th class="gray">안전관리자</th>
            <th class="gray">관리책임자</th>
          </tr>
          <tr>
            <td>
              <div style="height: 80px">
                <img v-if="!!form.sign1.sign" :src="form.sign1.sign" class="w-full h-full object-contain" />
              </div>
            </td>
            <td>
              <div style="height: 80px">
                <img v-if="!!form.sign2.sign" :src="form.sign2.sign" class="w-full h-full object-contain" />
              </div>
            </td>
          </tr>
        </table>
      </div>
      <table style="margin-top: -1px">
        <colgroup>
          <col width="180" />
          <col width="180" />
          <col />
          <col width="180" />
          <col width="180" />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <th>교육일시</th>
            <td colspan="5">{{ form.inputA_4 }}, {{ form.inputA_5 }} ~ {{ form.inputA_6 }}</td>
          </tr>
          <tr>
            <th>교육명</th>
            <td colspan="2">{{ form.inputA_3 }}</td>
            <th>교육구분</th>
            <td colspan="2">{{ form.inputA_1.value }}</td>
          </tr>
          <tr>
            <th>교육장소</th>
            <td colspan="2">{{ form.inputA_7 }}</td>
            <th>교육내용 반영 재해형태</th>
            <td colspan="2">{{ form.inputA_8.join(", ") }}</td>
          </tr>
          <tr>
            <th>대상(작업명)</th>
            <td colspan="5">{{ form.inputA_12 }}</td>
          </tr>
          <tr>
            <th rowspan="3">교육실시자</th>
            <th>교육 실시자 성명</th>
            <td colspan="4">{{ form.inputA_9 }}</td>
          </tr>
          <tr>
            <th>교육 실시자 소속</th>
            <td colspan="4">{{ form.inputA_10 }}</td>
          </tr>
          <tr>
            <th>교육 실시자 직책</th>
            <td colspan="4">{{ form.inputA_11 }}</td>
          </tr>
          <tr>
            <th rowspan="3">교육인원</th>
            <th>교육 대상</th>
            <td colspan="4">{{ form.inputA_12 }}</td>
          </tr>
          <tr>
            <th>교육 실시 인원(명)</th>
            <td colspan="4">{{ form.inputA_13 }}</td>
          </tr>
          <tr>
            <th>교육 미실시 인원(명)</th>
            <td colspan="4">{{ form.inputA_14 }}</td>
          </tr>
          <tr>
            <th>교육내용</th>
            <td colspan="5">
              <div class="print-textarea no-block" style="min-height: 300px; padding: 12px !important">
                {{ form.inputA_15 }}
              </div>
            </td>
          </tr>
          <tr>
            <th>근로자 의견</th>
            <td colspan="5">
              <div class="print-textarea no-block" style="min-height: 300px; padding: 12px !important">
                {{ form.inputA_16 }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="print-break">
      <!--참석자 명단-->
      <h2 style="line-height: 34px; margin-bottom: 10px">참석자 명단</h2>
      <div class="flex gap-5  mt-4">
        <div class="flex-1 flex items-center">
          <div style="width: 100px; font-size: 14px; font-weight: 500; line-height: 20px; padding: 0 7px">교육구분</div>
          <span class="print-input flex-1"> {{ !!form.inputA_1 ? form.inputA_1.value : "" }} </span>
        </div>
        <div class="flex-1 flex items-center">
          <div style="width: 100px; font-size: 14px; font-weight: 500; line-height: 20px; padding: 0 7px">교육일</div>
          <span class="print-input flex-1"> {{ form.inputA_4 }}, {{ form.inputA_5 }} ~ {{ form.inputA_6 }} </span>
        </div>
      </div>

      <div style="margin-top: 24px" class="flex gap-3 pageBreak">
        <table class="employee">
          <colgroup>
            <col width="64" />
          </colgroup>
          <tbody>
            <tr>
              <th class="px-0">No.</th>
              <th>ID(사번)</th>
              <th>부서명</th>
              <th>직종</th>
              <th>이름</th>
              <th>비고</th>
            </tr>
            <tr v-for="index in 20" :key="index">
              <th class="px-0">{{ index }}</th>
              <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].employee_id : "" }}</td>
              <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].com_name : "" }}</td>
              <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].employment_type : "" }}</td>
              <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].full_name : "" }}</td>
              <td>{{ !!employeeList[index - 1] ? employeeList[index - 1].note : "" }}</td>
            </tr>
          </tbody>
        </table>
        <table class="employee">
          <colgroup>
            <col width="64" />
          </colgroup>
          <tbody>
            <tr>
              <th class="px-0">No.</th>
              <th>ID(사번)</th>
              <th>부서명</th>
              <th>직종</th>
              <th>이름</th>
              <th>비고</th>
            </tr>
            <tr v-for="index in 20" :key="index + 20">
              <th class="px-0">{{ index + 20 }}</th>
              <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].employee_id : "" }}</td>
              <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].com_name : "" }}</td>
              <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].employment_type : "" }}</td>
              <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].full_name : "" }}</td>
              <td>{{ !!employeeList[index + 20 - 1] ? employeeList[index + 20 - 1].note : "" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 사진대지 -->
    <photo-upload-grid-module v-model="form.photoList" :is-print="true" :customTitle="true" section-title="사진대지" placeholder="점검 현장 사진">
      <template #customTitle>
        <div style="font-size: 24px; font-weight: 700; line-height: 35px; margin-bottom: 16px">□ 사진대지</div>
      </template>
    </photo-upload-grid-module>
  </div>
</template>

<script>
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import { getFieldLabel } from "@/util/DataUtil";

export default {
  name: "Print",
  components: {
    PhotoUploadGridModule,
  },
  props: {
    form: Object,
    employeeList: Array,
    board: Object,
  },
  computed: {
    getFieldLabel() {
      return getFieldLabel;
    },
  },
  methods: {
    getCheckBoxUrl(checked) {
      if (checked) {
        return `@/assets/images/print/print_check_checked.svg`;
      } else {
        return `@/assets/images/print/print_check_unchecked.svg`;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  text-align: center;
  font-weight: 700;
  font-size: 32px;
  line-height: 46px;
  margin-bottom: 64px;
}
h2 {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  line-height: 35px;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #757575;
    text-align: center;
    min-height: 60px;
    height: 60px;
    font-size: 18px;
  }
  th {
    background-color: #ececec;
    font-weight: 500;
    padding: 0;
    word-break: keep-all;
  }
  td {
    min-width: 50px;
    word-break: keep-all;
    img {
      display: inline-block;
    }
  }
  .th-background {
    background-color: #ececec;
    white-space: nowrap;
  }
  .check-container {
    padding: 10px 14px 0 14px;
    text-align: left;

    div {
      margin-bottom: 8px;
    }
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text-left {
    text-align: left;
    padding: 10px 14px;
  }
}
.print-break {
  break-inside: avoid;
}
.print-break-page {
  page-break-before: always;
}
</style>
